import { AuthContext } from '@contexts/Auth';
import { useContext } from 'react';

export const useAuth = () => {
	const ctx = useContext(AuthContext);
	if (!ctx) {
		throw new Error('useAuth must be used within AuthProvider');
	}
	return ctx;
};
